import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function EmailSent() {
    // const token = getToken();

    return (
        <div
            className="card mb-5 mb-xl-8 mt-19"

        >
            <div className="container h-1000px">

                <div className="bg-body text-center rounded shadow-sm p-10 p-lg-15 ms-19 mt-19">
                    <div className="row">
                        <div className="col-12 mt-7 fs-1"> Thank you for connecting with us!</div>
                        <div className="col-12 mt-7 fs-1 "> We'll get back to you shortly! </div>
                        <div className="col-12 mt-7"> <Link className="btn btn-dark" to={`/lingostory`}>
                            Explore the Books
                        </Link> </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
